<template>
  <tbody>
    <tr>
      <td>
        <div>
          {{ note.createdDate | formatDateMMDDYYYY  }}
        </div>
      </td>
      <td>
        <strong>
          {{ createdByDisplayName }}
        </strong>
      </td>
      <td>
        {{ mapNoteType(note.type) }}
      </td>
      <td class="note-content">
        <div>
          {{ note.content }}
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    note: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      noteTypeOptions: [],
    };
  },
  created() {
    this.noteTypeOptions = [
      {
        code: 'ADMIN',
        description: 'Admin',
      },
      {
        code: 'GENERAL',
        description: 'General',
      },
    ];
  },
  computed: {
    createdByDisplayName() {
      return `${this.note.createdByLastName}, ${this.note.createdByFirstName}`;
    },
  },
  methods: {
    mapNoteType(noteCode) {
      return this.noteTypeOptions.find(n => n.code === noteCode).description;
    },
  },
  filters: {
    formatDateMMDDYYYY(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return 'N/A';
    },
  },
};
</script>

<style lang="sass" scoped>
  .note-content
    word-break: break-word
</style>
